import { useOutletContext } from 'react-router';
import { Device } from '../../types';

/**
 * Plan 94 - context passed from DeviceWorkspaceLayout to its tab outlet.
 * The layout has already resolved the route `:deviceId` to a Device, so tab
 * components consume the device directly instead of carrying their own selector.
 */
export interface WorkspaceContext {
  device: Device;
  /**
   * FS-502 — reload the device from the API without remounting the tab. A tab
   * that writes to the homeowner's Firestore records uses it to pick the
   * change up once the sync queue has rebuilt the projection behind it.
   */
  refetchDevice?: () => void;
}

export const useWorkspaceDevice = (): WorkspaceContext => useOutletContext<WorkspaceContext>();
